window.updateCartVariant = function updateCartVariant(selectElement) {
  const line = Number(selectElement.dataset.line);
  const quantity = Number(selectElement.dataset.quantity);
  const selectedOption = selectElement.selectedOptions && selectElement.selectedOptions[0];
  const maxValues = [Number(selectElement.dataset.maxQuantity), Number(selectedOption?.dataset.optionMaxQuantity)].filter(Number.isFinite);
  const maxQuantity = maxValues.length ? Math.min(...maxValues) : quantity;
  const itemQuantity = Math.min(quantity, maxQuantity);
  const newVariantId = Number(selectedOption?.dataset.variantId || selectElement.value);
  const originalVariantId = selectElement.dataset.originalVariant;
  const sellingPlan = selectElement.dataset.sellingPlan ? Number(selectElement.dataset.sellingPlan) : null;
  const cartItems = selectElement.closest('cart-items, cart-drawer-items');

  function parseJson(text) {
    try {
      return text ? JSON.parse(text) : {};
    } catch (error) {
      return {};
    }
  }

  function addVariant(includeSellingPlan) {
    const payload = {
      items: [
        {
          id: newVariantId,
          quantity: itemQuantity,
          ...(includeSellingPlan && sellingPlan && { selling_plan: sellingPlan }),
        },
      ],
    };

    return fetch(routes.cart_add_url || '/cart/add.js', {
      ...fetchConfig(),
      body: JSON.stringify(payload),
    }).then((response) => response.text().then((text) => ({ ok: response.ok, text, status: response.status })));
  }

  function refreshDrawer(isEmpty) {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceDrawerInner = html.querySelector('#CartDrawer .drawer__inner');
        const targetDrawerInner = document.querySelector('#CartDrawer .drawer__inner');

        if (sourceDrawerInner && targetDrawerInner) {
          targetDrawerInner.innerHTML = sourceDrawerInner.innerHTML;
        }

        const cartDrawer = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const targetCartDrawerItems = document.querySelector('cart-drawer-items');

        if (targetCartDrawerItems) {
          targetCartDrawerItems.classList.toggle('is-empty', isEmpty);
        }

        if (cartDrawer) {
          cartDrawer.classList.toggle('is-empty', isEmpty);
        }

        if (cartFooter) {
          cartFooter.classList.toggle('is-empty', isEmpty);
        }
      });
  }

  selectElement.disabled = true;

  if (cartItems && typeof cartItems.enableLoading === 'function') {
    cartItems.enableLoading(line);
  }

  fetch(routes.cart_change_url || '/cart/change.js', {
    ...fetchConfig(),
    body: JSON.stringify({ line, quantity: 0 }),
  })
    .then((response) => response.text().then((text) => ({ ok: response.ok, text, status: response.status })))
    .then(({ ok, text, status }) => {
      const updatedCart = parseJson(text);
      // if(response.status === 422){
      //   return addVariant(true);
      // }

      if (!ok) {
        throw new Error(updatedCart.description || updatedCart.message || 'Failed to update cart.');
      }

      if (updatedCart.errors) {
        throw new Error(
          typeof updatedCart.errors === 'string' ? updatedCart.errors : updatedCart.message || 'Failed to update cart.'
        );
      }

      return addVariant(true);
    })
    .then(({ ok, text, status }) => {
      const updatedCart = parseJson(text);

      if (!ok && sellingPlan) {
        return addVariant(false).then(({ ok: retryOk, text: retryText }) => {
          const retryCart = parseJson(retryText);
          if(status === 422){
            refreshDrawer(updatedCart.item_count === 0);
          }

          if (!retryOk) {
            throw new Error(retryCart.description || retryCart.message || 'Failed to update variant.');
          }

          if (retryCart.errors) {
            throw new Error(
              typeof retryCart.errors === 'string' ? retryCart.errors : retryCart.message || 'Failed to update variant.'
            );
          }

          return refreshDrawer(retryCart.item_count === 0);
        });
      }
      if(status === 422){
        refreshDrawer(updatedCart.item_count === 0);
      }

      if (status != 422 && !ok) {
        throw new Error(updatedCart.description || updatedCart.message || 'Failed to update variant.');
      }

      if (status != 422 && updatedCart.errors) {
        throw new Error(
          typeof updatedCart.errors === 'string' ? updatedCart.errors : updatedCart.message || 'Failed to update variant.'
        );
      }

      return refreshDrawer(updatedCart.item_count === 0);
    })
    .catch((error, status) => {
      if(status!=422){
      console.error('Variant update error:', error);
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

      if (errors) {
        errors.textContent = error.message || (window.cartStrings && window.cartStrings.error) || 'Failed to update variant.';
      }

      if (originalVariantId) {
        selectElement.value = originalVariantId;
      }
    }
    })
    .finally(() => {
      selectElement.disabled = false;

      if (cartItems && typeof cartItems.disableLoading === 'function') {
        cartItems.disableLoading(line);
      }
    });
};

window.getUpdatedSectionInnerHTML = function getUpdatedSectionInnerHTML(html, selector = '.shopify-section') {
  const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
  const element = parsedHtml.querySelector(selector);

  return element ? element.innerHTML : null;
};

window.loadConsentContent = function loadConsentContent(clickedElement) {
  const parent = clickedElement.closest('.subscription-info');
  const source = document.getElementById('shopify-buyer-consent');
  const target = parent.querySelector('.tool');

  if (source && target) {
    if (!target.contains(source)) {
      target.appendChild(source);
    }

    if (target.style.display === 'none' || target.style.display === '') {
      target.style.display = 'block';
      source.setAttribute('style', 'display: inline !important;');
    } else {
      target.style.display = 'none';
    }
  } else {
    target.innerText = 'Consent information not found.';
  }
};

window.updatecartSellingPlan = function updatecartSellingPlan(selectElement) {
  const line = Number(selectElement.dataset.line);
  const quantity = Number(selectElement.dataset.quantity);
  const selling_plan = selectElement.value ? Number(selectElement.value) : null;
  const cartItems = selectElement.closest('cart-items, cart-drawer-items');
  const sectionsToRender =
    cartItems && typeof cartItems.getSectionsToRender === 'function' ? cartItems.getSectionsToRender() : [];

  const data = {
    line,
    quantity,
    selling_plan,
    sections: sectionsToRender.map((section) => section.section || section.id),
    sections_url: window.location.pathname,
  };

  selectElement.disabled = true;

  if (cartItems && typeof cartItems.enableLoading === 'function') {
    cartItems.enableLoading(line);
  }

  fetch(routes.cart_change_url || '/cart/change.js', {
    ...fetchConfig(),
    body: JSON.stringify(data),
  })
    .then((response) => response.text().then((text) => ({ ok: response.ok, text })))
    .then(({ ok, text }) => {
      const updatedCart = text ? JSON.parse(text) : {};

      if (!ok) {
        throw new Error(updatedCart.description || updatedCart.message || 'Failed to update cart.');
      }

      return updatedCart;
    })
    .then((updatedCart) => {
      if (updatedCart.errors) {
        throw new Error(
          typeof updatedCart.errors === 'string' ? updatedCart.errors : updatedCart.message || 'Failed to update cart.'
        );
      }

      const cartDrawer = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartItems) {
        cartItems.classList.toggle('is-empty', updatedCart.item_count === 0);
      }

      if (cartDrawer) {
        cartDrawer.classList.toggle('is-empty', updatedCart.item_count === 0);
      }

      if (cartFooter) {
        cartFooter.classList.toggle('is-empty', updatedCart.item_count === 0);
      }

      sectionsToRender.forEach((section) => {
        const container = document.getElementById(section.id);
        const sectionHtml = updatedCart.sections && updatedCart.sections[section.section || section.id];

        if (!container || !sectionHtml) return;

        const elementToReplace = section.selector ? container.querySelector(section.selector) || container : container;
        const nextInnerHtml = window.getUpdatedSectionInnerHTML(sectionHtml, section.selector || '.shopify-section');

        if (nextInnerHtml !== null) {
          elementToReplace.innerHTML = nextInnerHtml;
        }
      });
    })
    .catch((error) => {
      console.error('Error:', error);
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = error.message || (window.cartStrings && window.cartStrings.error) || 'Failed to update cart.';
      }
    })
    .finally(() => {
      selectElement.disabled = false;

      if (cartItems && typeof cartItems.disableLoading === 'function') {
        cartItems.disableLoading(line);
      }
    });
};
